import React, { useState, useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Lottie from "lottie-react";
import notfoundData from "../../assets/not_found.json";
import "./NewVendor.css";
import {
  IconCreditCard,
  IconTrash,
  IconPencil,
  IconBrandVisa,
  IconEye,
  IconTrendingUp2,
  IconBuildingBank,
  IconAsterisk,
} from "@tabler/icons-react";

import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Card,
  Button,
} from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, handleKeyDown } from "../../constant/_constant";
import { useSelector } from "react-redux";
function VendorCard({ show, setShow, auto_id }) {
  const validationSchema = yup.object({
    paymentMethod: yup.string().required("Payment method is required"),

    cardHolderName: yup
      .string()
      .test(
        "required-if-creditCard",
        "Cardholder name is required",
        function (value) {
          const { paymentMethod } = this.parent; // Access parent fields (paymentMethod)
          if (paymentMethod === "creditCard" && !value) {
            return false;
          }
          return true;
        }
      ),
    cardNumber: yup
      .string()
      .test(
        "required-if-creditCard",
        "Card number is required",
        function (value) {
          const { paymentMethod } = this.parent;
          const strippedValue = value ? value.replace(/\s+/g, "") : "";
          if (paymentMethod === "creditCard") {
            if (!strippedValue) {
              return this.createError({
                message: "Card number is required",
              });
            }

            // Check if the length is 15 or 16 digits
            if (strippedValue.length < 15 || strippedValue.length > 16) {
              return this.createError({
                message: "Card number must be 15 or 16 digits",
              });
            }

            // Check if it contains only digits
            if (!/^\d{16}$/.test(strippedValue)) {
              return this.createError({
                message: "Card number must contain only digits",
              });
            }
          }
          return true;
        }
      ),

    expiry: yup
      .string()
      .test(
        "required-if-creditCard",
        "Expiry date is required",
        function (value) {
          const { paymentMethod } = this.parent;
          if (paymentMethod === "creditCard" && !value) {
            return false;
          }
          if (
            paymentMethod === "creditCard" &&
            value &&
            !/^(0[1-9]|1[0-2])\/\d{2}$/.test(value)
          ) {
            return this.createError({
              message: "Expiry date must be in MM/YY format",
            });
          }
          return true;
        }
      ),

    routingNumber: yup
      .string()
      .test(
        "required-if-bankAccount",
        "Routing number is required",
        function (value) {
          const { paymentMethod } = this.parent;
          if (paymentMethod === "bankAccount" && !value) {
            return false;
          }
          if (paymentMethod === "bankAccount" && value && value.length !== 9) {
            return this.createError({
              message: "Routing number must be 9 digits",
            });
          }
          return true;
        }
      )
      .matches(/^\d{9}$/, "Routing number must be 9 digits and numeric"),

    accountNumber: yup
      .string()
      .test(
        "required-if-bankAccount",
        "Account number is required",
        function (value) {
          const { paymentMethod } = this.parent;
          if (paymentMethod === "bankAccount" && !value) {
            return false; // Return false if no value is provided for account number
          }
          return true;
        }
      )
      .matches(
        /^\d{8,16}$/,
        "Account number must be between 8 and 16 digits and numeric"
      ) // Ensure it's between 8 and 16 digits
      .min(8, "Account number must be at least 8 digits") // Minimum length check
      .max(16, "Account number must be no more than 16 digits"), // Maximum length check

    bankName: yup
      .string()
      .test(
        "required-if-bankAccount",
        "Bank name is required",
        function (value) {
          const { paymentMethod } = this.parent;
          if (paymentMethod === "bankAccount" && !value) {
            return false;
          }
          return true;
        }
      ),

    companyName: yup
      .string()
      .test(
        "required-if-bankAccount",
        "Company name is required",
        function (value) {
          const { paymentMethod } = this.parent;
          if (paymentMethod === "bankAccount" && !value) {
            return false;
          }
          return true;
        }
      ),
  });

  const [paymentMethod, setPaymentMethod] = useState("bankAccount");
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: {
      paymentMethod: paymentMethod,
    },
  });

  const [flippedCardIndex, setFlippedCardIndex] = useState(null);

  const handlePaymentMethodChange = (e) => {
    reset();
    setPaymentMethod(e.target.value);
    setValue("paymentMethod", e.target.value);
  };
  const [addCard, setAddCard] = useState(false);

  const handleCancel = () => {
    setAddCard(false);
    reset();
  };

  const handleAddCardClick = (e) => {
    // e.preventDefault();
    setAddCard(true);
  };

  const { isLoading, postData } = usePostRequest(
    API_ENDPOINTS.CREATE_CARD_INFO_VENDOR
  );

  const { isLoading: deleteLoading, postData: DeleteCard } = usePostRequest(
    API_ENDPOINTS.DELETE_CARD_INFO_VENDOR
  );

  const {
    data: cardData,
    isLoading: isLoadingCard,
    postData: fetchCard,
  } = usePostRequest(API_ENDPOINTS.GET_CARD_INFO_VENDOR);

  const onSuccess = (response) => {
    reset();
    fetchCard({ auto_id: auto_id });
    toast.success(response?.message);
    setAddCard(false);
  };

  const onError = (error) => {
    toast.error(error?.message);
  };

  const onSubmit = (data) => {
    const payload = {
      auto_id: auto_id,
      info_number: data.cardNumber
        ? data.cardNumber.replace(/\s+/g, "")
        : data.accountNumber,
      info_expiry: data.expiry ? data.expiry : null,
      info_name: data.cardHolderName || data.companyName,
      info_routing: data.routingNumber ? data.routingNumber : null,
      info_bank: data.bankName ? data.bankName : null,
      method: paymentMethod === "creditCard" ? "CC" : "WT",
    };
    console.log(payload);
    postData(payload, onSuccess, onError);
  };

  useEffect(() => {
    fetchCard({ auto_id: auto_id });
  }, [auto_id]);

  // OTP_Form

  const handleDeleteClick = (index) => {
    if (flippedCardIndex === index) {
      setFlippedCardIndex(null);
    } else {
      setFlippedCardIndex(index);
    }
  };

  const onSuccessDelete = (res) => {
    fetchCard({ auto_id: auto_id });
    toast.success(res?.message);
    setFlippedCardIndex(null);
  };

  const onErrorDel = (error) => {
    toast.error(error?.message);
  };

  const handleDelete = (id) => {
    DeleteCard({ id: id }, onSuccessDelete, onErrorDel);
  };

  const formatCardNumber = (value) => {
    value = value || "";
    return value.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
  };
  const formatExpiryDate = (value) => {
    value = value || "";
    value = value.replace(/\D/g, "");
    if (value.length <= 2) {
      return value;
    } else {
      return value.slice(0, 2) + "/" + value.slice(2, 4); // Format as MM/YY
    }
  };

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");
  const canDeleteCards = user?.permissions?.manage_cards?.includes("delete");

  return (
    <Modal
      scrollable={true}
      dialogClassName="modal-90w"
      size="lg"
      show={show}
      onHide={() => setShow({ show: false })}
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2 justify-content-between pe-5" closeButton>
        <div className="d-flex align-items-center gap-2">
          <span className="avatar bg-indigo-lt rounded-circle">
            <IconCreditCard />
          </span>
          <Modal.Title>Payment Details</Modal.Title>
        </div>

        <span
          className="add_new_card bg-indigo"
          style={{ cursor: !canEditCards ? "not-allowed" : "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            if (canEditCards) {
              handleAddCardClick();
            }
          }}
        >
          Add Payment Details
        </span>
      </Modal.Header>
      <Modal.Body>
        <Row className="justify-content-center">
          <Col md={11}>
            {addCard && (
              <>
                <Card className="add_credit_card mb-3">
                  <Card.Header className="card_header">
                    PAYMENT CARD
                  </Card.Header>
                  <Card.Body>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      {/* <div md={12}>
                        <Form.Group className="mb-3 d-flex gap-3">
                          <Form.Label className="mb-0">SElECT PAYMENT METHOD</Form.Label>
                          <Form.Check
                            type="radio"
                            id="creditCard"
                            label="Credit Card"
                            name="paymentMethod"
                            value="creditCard"
                            checked={paymentMethod === "creditCard"}
                            onChange={handlePaymentMethodChange}
                          />
                          <Form.Check
                            type="radio"
                            id="bankAccount"
                            label="Wire Transfer"
                            name="paymentMethod"
                            value="bankAccount"
                            checked={paymentMethod === "bankAccount"}
                            onChange={handlePaymentMethodChange}
                          />
                        </Form.Group>
                      </div> */}

                      {paymentMethod === "creditCard" && (
                        <Row className="creditCard">
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                CARDHOLDER NAME
                              </Form.Label>
                              <InputGroup>
                                <Controller
                                  name="cardHolderName"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      placeholder="Enter CardHolder Name"
                                      onChange={(e) => {
                                        field.onChange(e);
                                        trigger("cardHolderName"); // Trigger validation on change
                                      }}
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.cardHolderName && (
                                <div className="text-danger">
                                  {errors.cardHolderName.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={8}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                CARD NUMBER
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Text>
                                  <IconBrandVisa stroke={1} />
                                </InputGroup.Text>
                                <Controller
                                  name="cardNumber"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      type="text"
                                      // maxLength={16}
                                      maxLength={19}
                                      value={formatCardNumber(field.value)}
                                      placeholder="**** **** **** ****"
                                      onChange={(e) => {
                                        const formattedValue = formatCardNumber(
                                          e.target.value
                                        );
                                        field.onChange(e);
                                        trigger("cardNumber"); // Trigger validation on change
                                      }}
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.cardNumber && (
                                <div className="text-danger">
                                  {errors.cardNumber.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                EXPIRY
                              </Form.Label>
                              <InputGroup>
                                <Controller
                                  name="expiry"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      maxLength={5}
                                      value={formatExpiryDate(field.value)}
                                      onChange={(e) => {
                                        const formattedValue = formatExpiryDate(
                                          e.target.value
                                        );
                                        setValue("expiry", formattedValue); // Update the value in form
                                        field.onChange(e);
                                        trigger("expiry"); // Trigger validation on change
                                      }}
                                      placeholder="MM/YY"
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.expiry && (
                                <div className="text-danger">
                                  {errors.expiry.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}

                      {paymentMethod === "bankAccount" && (
                        <Row className="bankAccount">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                COMPANY NAME
                              </Form.Label>
                              <InputGroup>
                                <Controller
                                  name="companyName"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      placeholder="Enter Company Name"
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.companyName && (
                                <div className="text-danger">
                                  {errors.companyName.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                BANK NAME
                              </Form.Label>
                              <InputGroup>
                                <Controller
                                  name="bankName"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      placeholder="Enter Bank Name"
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.bankName && (
                                <div className="text-danger">
                                  {errors.bankName.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                ROUTING NUMBER
                              </Form.Label>
                              <InputGroup>
                                <Controller
                                  name="routingNumber"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      maxLength={9}
                                      type="text"
                                      placeholder="**** **** **** ****"
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.routingNumber && (
                                <div className="text-danger">
                                  {errors.routingNumber.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label className="required">
                                ACCOUNT NUMBER
                              </Form.Label>
                              <InputGroup>
                                <Controller
                                  name="accountNumber"
                                  control={control}
                                  render={({ field }) => (
                                    <Form.Control
                                      {...field}
                                      maxLength={16}
                                      placeholder="Account Number"
                                    />
                                  )}
                                />
                              </InputGroup>
                              {errors.accountNumber && (
                                <div className="text-danger">
                                  {errors.accountNumber.message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}

                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          type="submit"
                          variant="warning"
                          disabled={isLoading}
                        >
                          Submit
                        </Button>
                        <Button
                          type="button"
                          variant="outline-secondary"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}

            {isLoadingCard ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <>
                {!addCard && (
                  <>
                    {cardData && cardData?.data.length > 0 ? (
                      cardData?.data?.map((card, index) => {
                        const isFlipped = flippedCardIndex === index;
                        return (
                          <>
                            <div
                              className={`card_body  ${
                                isFlipped ? "flipped" : ""
                              }`}
                              key={index}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <div className="icon-lt">
                                  {card?.info_bank ? (
                                    <IconBuildingBank stroke={1.5} />
                                  ) : (
                                    <IconCreditCard stroke={1.5} />
                                  )}
                                </div>
                                <div className="card_details">
                                  <div class="user_name mb-0 card-title h5">
                                    {card?.info_bank ? (
                                      <span className="aterisk_group">
                                        {card?.info_bank}
                                        <span className="four_aterisk">
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                        </span>
                                        <span className="four_aterisk">
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                        </span>
                                        <span className="four_aterisk">
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                        </span>
                                        {card?.info_number}
                                      </span>
                                    ) : (
                                      <span className="aterisk_group">
                                        Card
                                        <span className="four_aterisk">
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                        </span>
                                        <span className="four_aterisk">
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                        </span>
                                        <span className="four_aterisk">
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                          <IconAsterisk />
                                        </span>
                                        {card?.info_number}
                                      </span>
                                    )}
                                  </div>

                                  <p class="card_text mb-0">
                                    Name: {card?.info_name}{" "}
                                  </p>
                                </div>
                              </div>

                              <span className="">
                                <IconTrash
                                  // onClick={() => handleDeleteClick(index)}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (canDeleteCards) {
                                      handleDeleteClick(index);
                                    }
                                  }}
                                  style={{
                                    cursor: !canDeleteCards
                                      ? "not-allowed"
                                      : "pointer",
                                    color: "red",
                                  }}
                                  stroke={1}
                                />
                              </span>
                            </div>

                            {isFlipped && (
                              <div className="card_box_cnfirm mb-5">
                                <h6 className="cnfirm_heading text-center pt-1">
                                  Are you sure?
                                </h6>

                                <div className="confirmation-buttons d-flex justify-content-center gap-2 pt-1">
                                  <Button
                                    variant="warning"
                                    disabled={deleteLoading}
                                    onClick={() => handleDelete(card.id)}
                                  >
                                    {deleteLoading ? (
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      "Yes"
                                    )}
                                  </Button>
                                  <Button
                                    variant="outline-secondary"
                                    onClick={() => setFlippedCardIndex(null)}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })
                    ) : (
                      <div className="data_not_available text-center">
                        <Lottie animationData={notfoundData} />{" "}
                        <p> No Card available.</p>{" "}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default VendorCard;
